export const config = {
  env: import.meta.env.VITE_APP_ENV,
  envColor: import.meta.env.VITE_APP_ENV_COLOR,
  cognitoClientId: import.meta.env.VITE_APP_COGNITO_CLIENT_ID,
  cognitoUserPoolId: import.meta.env.VITE_APP_COGNITO_USER_POOL_ID,
  cognitoUserPoolRegion: import.meta.env.VITE_APP_COGNITO_USER_POOL_REGION,
  cognitoEndpoint: import.meta.env.VITE_APP_COGNITO_ENDPOINT,
  s3AttachmentsUrl: import.meta.env.VITE_S3_ATTACHMENTS_URL,
  s3PublicReadUrl: import.meta.env.VITE_S3_PUBLIC_READ_URL,
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  postHogHost: import.meta.env.VITE_APP_PUBLIC_POSTHOG_HOST,
  postHogKey: import.meta.env.VITE_APP_PUBLIC_POSTHOG_KEY,
  appVersion: import.meta.env.VITE_APP_VERSION || '0',
  clientFacingDomainName: import.meta.env.VITE_CLIENT_FACING_DOMAIN_NAME,
  flatfileToken: import.meta.env.VITE_FLATFILE_TOKEN,
};
